import {
  ColorInput,
  DecimalInput,
  FormItem,
  NumberInput,
  SelectInput,
  TextInput,
} from '@framework/form';
import { DividerTitleElement, RowElement } from '@framework/ui';
import * as React from 'react';
import { useMemo } from 'react';
import {
  DefaultMapLayerMinZoom,
  MapLayerType,
  MapLayerTypeOptions,
} from '../layers/MapLayer';

export interface IMapLayerConfigInputProps {
  name: string;
  allowedTypes?: MapLayerType[];
}

/**
 * Permette di definire le proprietà di un singolo livello della mappa.
 */
export function MapLayerConfigInput(props: IMapLayerConfigInputProps) {
  const { name, allowedTypes } = props;

  const allowedOptions = useMemo(() => {
    return allowedTypes
      ? MapLayerTypeOptions.filter(o => allowedTypes.includes(o.value))
      : MapLayerTypeOptions;
  }, [allowedTypes]);

  return (
    <div>
      <h3>Configurazione Livello</h3>
      <FormItem label="Tipo" name={`${name}type`}>
        <SelectInput name={`${name}type`} options={allowedOptions} />
      </FormItem>
      <FormItem label="Nome" name={`${name}name`}>
        <TextInput name={`${name}name`} />
      </FormItem>
      <FormItem label="URL" name={`${name}url`}>
        <TextInput name={`${name}url`} />
      </FormItem>
      <DividerTitleElement title="Stile" />
      <FormItem label="Colore di riempimento" name={`${name}style.fillColor`}>
        <ColorInput name={`${name}style.fillColor`} />
      </FormItem>
      <FormItem label="Colore del bordo" name={`${name}style.strokeColor`}>
        <ColorInput name={`${name}style.strokeColor`} />
      </FormItem>
      <FormItem label="Spessore del bordo" name={`${name}style.strokeWidth`}>
        <NumberInput min={0} name={`${name}style.strokeWidth`} />
      </FormItem>
      <FormItem
        label="Opacità"
        name={`${name}style.opacity`}
        help="Un valore pari a 0 renderizza il livello completamente trasparente, un valore pari a 1 completamente opaco"
      >
        <DecimalInput min={0} max={1} name={`${name}style.opacity`} />
      </FormItem>
      <FormItem
        label="Etichetta"
        name={`${name}labelPropertyName`}
        help="Se specificato, verrà visualizzato un'etichetta per ogni geometria del layer. Il valore dell'etichetta sarà preso dalla proprietà indicata."
      >
        <TextInput name={`${name}labelPropertyName`} />
      </FormItem>
      <RowElement>
        <FormItem
          label="Zoom Minimo"
          name={`${name}minZoom`}
          help="In caso di layer vettoriali con elevato numero di Geometrie, è possibile configurare questo valore per attivare il layer solamente dopo il livello di zoom indicato. Lo zoom minimo è 0, lo zoom massimo è 20"
        >
          <NumberInput
            min={0}
            max={20}
            name={`${name}minZoom`}
            placeholder={String(DefaultMapLayerMinZoom)}
          />
        </FormItem>
      </RowElement>
    </div>
  );
}
